import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostIssueFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            DefaultApi({
                params,
                method: 'post',
                url: urls.GET_ISSUE_FREESPIN
            });
            alert('Фриспин создан')
        } catch (error) {
            //todo доделать catch 
            alert('Ошибка создания')
            getCatchError(error)
        }
    }
}

export {
    setPostIssueFreespin as SetPostIssueFreespin
}